module.exports = __webpack_public_path__ + "static/media/19ESCAP33.6aa13ff6.jpg";